import React, { Component } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { message } from 'antd'

export default class CopyClipboard extends Component {

  copyHandle = (text, result) => {
    if (result) {
      message.success('复制成功', 1.5)
    } else {
      message.error('复制失败', 1.5)
    }
  }
  render() {
    let { text = '' } = this.props
    // 去除所有html标签
    text = text.replace(/<[^>]+>/g, '')
    return (
      <span className="copy-clipboard-w">
        <CopyToClipboard text={text} onCopy={this.copyHandle}>
          <span className="copy-btn">复制</span>
        </CopyToClipboard>
      </span>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/common/CopyClipboard/index.js